const BackgroundCheckRanges = [
    { name: 'Never', field: 'bgcNever', sfaField: 'fullBgcNever' },
    { name: '> 10 years ago', field: 'bgc10Year', sfaField: 'fullBgc10Year' },
    { name: '5-10 years ago', field: 'bgc5to10Year', sfaField: 'fullbgc5to10Year' },
    { name: '2-5 years ago', field: 'bgc2to5Year', sfaField: 'fullBgc2to5Year' },
    { name: '1 year ago', field: 'bgc1Year', sfaField: 'fullBgc1Year' },
]

export { BackgroundCheckRanges }